module.exports = __webpack_public_path__ + "assets/images/slide2.jpg?_d2fed556f7bb";